import { render, staticRenderFns } from "./ContactsModuleComponent.vue?vue&type=template&id=1cbcbcef&scoped=true"
import script from "./ContactsModuleComponent.vue?vue&type=script&lang=js"
export * from "./ContactsModuleComponent.vue?vue&type=script&lang=js"
import style0 from "./ContactsModuleComponent.vue?vue&type=style&index=0&id=1cbcbcef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbcbcef",
  null
  
)

export default component.exports